<template>
  <v-dialog
    v-model="getModalCadastroNCM"
    persistent
    transition="dialog-transition"
    max-width="720px"
  >
    <v-card>
      <v-card-title>Cadastro de NCM</v-card-title>
      <v-card-text>
        <v-form class="px-3 mt-4" ref="formNCM">
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-text-field
                label="Código"
                v-model="getNCM.codigo"
                outlined
                dense
                :rules="rules.codigo"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                label="Descrição"
                v-model="getNCM.descricao"
                outlined
                dense
                :rules="rules.descricao"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                label="Alíquita Nacional"
                v-model="getNCM.nacionalfederal"
                outlined
                dense
                :rules="rules.nacionalfederal"
                v-mask="['#,##', '##,##']"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                label="Alíquita Importação"
                v-model="getNCM.importadosfederal"
                outlined
                dense
                :rules="rules.importadosfederal"
                v-mask="['#,##', '##,##']"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                label="Alíquita Estadual"
                v-model="getNCM.estadual"
                outlined
                dense
                v-mask="['#,##', '##,##']"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                label="Alíquita Municial"
                v-model="getNCM.municipal"
                outlined
                dense
                v-mask="['#,##', '##,##']"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="default" outlined @click="setModalCadastroNCM(false)"
          >Fechar</v-btn
        >
        <v-btn color="error" outlined @click="setModalExcluirNCM(true)" v-if="getNCM.id"
          >Excluir</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="success" outlined @click="salvar()">Salvar</v-btn>
      </v-card-actions>
      
    </v-card>
    <ModalExcluir />
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalExcluir from "@/pages/ncm/ModalExcluir"
export default {
  components: {
    ModalExcluir
  },
  data() {
    return {
      rules: {
        codigo: [(v) => !!v || "Campo obrigatório."],
        descricao: [(v) => !!v || "Campo obrigatório."],
        nacionalfederal: [(v) => !!v || "Campo obrigatório."],
        importadosfederal: [(v) => !!v || "Campo obrigatório."],
        estadual: [(v) => !!v || "Campo obrigatório."],
        municipal: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },
  computed: {
    ...mapGetters(["getModalCadastroNCM", "getNCM"]),
  },
  methods: {
    ...mapActions([
      "salvarNCM",
      "atualizarNCM",
      "setModalExcluirNCM",
      "setModalCadastroNCM",
    ]),
    salvar() {
      if (this.$refs.formNCM.validate() == false) {
        return;
      }
      if (this.getNCM.id) {
        this.atualizarNCM(this.getNCM);
      } else {
        this.salvarNCM(this.getNCM);
      }
    },
  },
};
</script>